import { render, staticRenderFns } from "./Privacy_policy.vue?vue&type=template&id=412363c3&scoped=true"
import script from "./Privacy_policy.vue?vue&type=script&lang=js"
export * from "./Privacy_policy.vue?vue&type=script&lang=js"
import style0 from "./Privacy_policy.vue?vue&type=style&index=0&id=412363c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412363c3",
  null
  
)

export default component.exports